<template>
  <div class="component-container">
    <label v-if="showLabel()" :style="lableStyle"
      ><span class="xing" :style="required ? { color: '#f00' } : null">*</span
      >{{ label }}</label
    >
    <el-tooltip
      :disabled="disabledTooltip() || !isedite"
      :content="tooltip"
      placement="top-start"
    >
      <el-input
        :disabled="!isedite"
        :style="inputStyle"
        :placeholder="placeholder"
        v-model="val"
        ref="component"
        @keyup.enter.native="handleEnter"
        @blur="handleBlur"
      />
    </el-tooltip>
  </div>
</template>

<script>
import _ from 'lodash'
import * as constants from '@/constants'
import * as storage from '@/utils/storage'
import PageModel from '../../models/page'

export default {
  name: 'jtlimitText',
  props: {
    label: {
      type: String,
      default: '',
    },
    labelWidth: {
      type: String,
      default: '30%',
    },
    value: {
      type: String,
      default: '',
    },
    compWidth: {
      type: String,
      default: '100%',
    },
    placeholder: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    minLength: {
      type: Number,
      default: 1,
    },
    maxLength: {
      type: Number,
      default: 100,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    expression: {
      type: String,
      default: '',
    },
    alwaysEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      val: this.value,
      lableStyle: {
        width: window.innerWidth > 768 ? this.labelWidth : '100%',
      },
      inputStyle: {
        width: window.innerWidth > 768 ? this.compWidth : '100%',
      },
      hasFiredEnterEventHandler: false,
    }
  },
  watch: {
    value(newValue) {
      this.val = newValue
    },
  },
  computed: {
    isedite() {
      if (this.alwaysEdit) {
        return true
      } else {
        return this.editable
      }
    },
  },
  methods: {
    showLabel() {
      return !_.isEmpty(_.trim(this.label))
    },
    disabledTooltip() {
      return _.isEmpty(_.trim(this.tooltip))
    },
    focus() {
      this.$refs.component.focus()
    },
    handleEnter() {
      try {
        this.hasFiredEnterEventHandler = true
        this.$emit('enter')
        this.handleBlur()
      } catch (err) {
        this.$emit('datas', err, null)
      }
    },

    async handleBlur() {
      const oldGoods = this.value
      const goods = _.trim(this.val)
      if (oldGoods !== goods) {
        if (this.hasFiredEnterEventHandler) {
          this.hasFiredEnterEventHandler = false
        }
        try {
          let data = await PageModel.deduction(oldGoods, goods)
          if (data) {
            this.$emit('datas', null, goods)
          } else {
            this.val = ''
            this.$emit('datas', null, '')
          }
        } catch (error) {}
      }
    },

    // _save() {
    //   const value = _.trim(this.val)
    //   if (!_.isEmpty(value)) {
    //     let str1 = value.replace(/[\f\r\t]/g, '')
    //     this.val = str1
    //     this.$emit('datas', null, str1)
    //   } else {
    //     this.$emit('datas', null, value)
    //   }
    // },
    // async handleChange() {
    //   // this.$emit('enter')
    //   _.delay(() => this.$emit('datas', null, this.val), 300)
    //   let obj = _.find(this.options, (item) => item['商品'] == this.val)
    //   let config = storage.getItem(constants.GLOBAL_CONFIG)
    //   let { gameId, teamId } = config
    //   let xOldOrderId = this.orderId
    //   let colId = this.colId
    //   let rowId = this.rowId
    //   let qty = 1
    //   let xGoodsId = obj.xGoodsId
    //   let athlete = this.rowId
    //   let data = await PageModel.orderGoods(
    //     xOldOrderId,
    //     xGoodsId,
    //     gameId,
    //     teamId,
    //     athlete,
    //     qty,
    //     colId,
    //     rowId
    //   )
    // },
  },
}
</script>

<style lang="stylus">
.sel {
  .el-select-dropdown__wrap {
    max-height: 474px;
  }

  .el-select-dropdown__item.hover {
    background-color: #8cc5ff;
  }
}
</style>
